<template>
  <form-section
    id="violation_form"
    :headline="this.$t('form.violation.headline')"
  >
    <textfield
      id="agreement_description"
      :label="$t('form.violation.amount.label')"
      :placeholder="$t('form.violation.amount.placeholder')"
      v-model="violation.amount"
      isRequired
      v-on:focus="scrollTo('#violation_contract')"
    />
  </form-section>
</template>

<script>
import FormSection from "@/shared/components/FormSection.vue";
import Textfield from "@/shared/components/Textfield.vue";
export default {
  components: {
    FormSection,
    Textfield,
  },
  data() {
    return {
      violation: {
        amount: "",
      },
    };
  },
  watch: {
    violation: {
      handler() {
        this.$store.commit("updateViolation", this.violation);
      },
      deep: true,
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/form/Violation.vue